import { createElement, type ReactElement } from 'react';
import { View } from 'react-native';
import { colors } from '../tokens';

export type CupProps = {
  tint: string;
  width?: number;
  /** Extra pearls at the bottom, used on the product detail hero. */
  pearls?: 3 | 4;
  /** `thumb` = body and lid only, as drawn in the small cart line squares. */
  variant?: 'full' | 'thumb';
  /** Faint liquid line across the cup (hero illustration). */
  shine?: boolean;
  /** Product photo; replaces the illustration when set. */
  imageUrl?: string | null;
};

/** The milk-tea cup illustration used everywhere a product photo would go. */
export const Cup = ({ tint, width = 72, pearls = 3, variant = 'full', shine = false, imageUrl }: CupProps): ReactElement => {
  const height = (width * 80) / 64;
  if (imageUrl) {
    const img = createElement('img', { src: imageUrl, alt: '', loading: 'lazy', width, height, style: { display: 'block', objectFit: 'contain', width, height } });
    return <View style={{ width, height }}>{img}</View>;
  }
  const full = variant === 'full';
  const pearl = (cx: number, cy: number, key: string) => createElement('circle', { key, cx, cy, r: 2.6, fill: colors.navy, fillOpacity: 0.55 });
  const svg = createElement(
    'svg',
    { viewBox: '0 0 64 80', width, height, 'aria-hidden': true, style: { display: 'block' } },
    createElement('path', { key: 'body', d: 'M14 24h36l-4 48a6 6 0 0 1-6 5H24a6 6 0 0 1-6-5z', fill: tint }),
    shine ? createElement('path', { key: 'shine', d: 'M15.6 38h32.8', stroke: '#FFFFFF', strokeOpacity: 0.3, strokeWidth: 1.5 }) : null,
    full ? pearl(25, 66, 'a') : null,
    full ? pearl(32, 69, 'b') : null,
    full ? pearl(39, 66, 'c') : null,
    full && pearls === 4 ? pearl(29, 62, 'd') : null,
    createElement('rect', { key: 'lid', x: 10, y: 17, width: 44, height: 8, rx: 4, fill: '#FFFFFF', stroke: colors.navy, strokeWidth: 2 }),
    full ? createElement('path', { key: 'straw', d: 'M36 17l7-14', stroke: colors.navy, strokeWidth: 3, strokeLinecap: 'round' }) : null,
  );
  return <View style={{ width, height }}>{svg}</View>;
};
